import { Flex, Box, Input, Text, InputGroup } from '@chakra-ui/react';
import { forwardRef, useCallback, useImperativeHandle, useRef } from 'react';
import FeatherIcon from '@ailibs/feather-react-ts';

type CircleFileUploadProps = {
  label?: string;
  accept?: string;
  onFileChange?: (file: File | undefined) => void;
  disabled?: boolean;
};

export const CircleFileUpload = forwardRef<HTMLInputElement, CircleFileUploadProps>((props, ref) => {
  const { label = 'Adicionar', accept = '.png, .jpg, .jpeg', onFileChange, disabled } = props;

  const innerRef = useRef<HTMLInputElement>(null);

  useImperativeHandle(ref, () => innerRef.current as HTMLInputElement);

  const onHandleFile = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const file = event?.target?.files?.[0];
      if (file) onFileChange?.(file);
    },
    [onFileChange],
  );

  return (
    <InputGroup w='fit-content'>
      <Flex
        position='relative'
        width='fit-content'
        direction='column'
        justifyContent='center'
        alignItems='center'
        gap={2}
        onClick={() => {
          if (disabled) return;
          innerRef.current?.click();
        }}
        cursor={disabled ? 'not-allowed' : 'pointer'}
        _hover={
          disabled
            ? undefined
            : {
                '& > div': {
                  bg: 'brand.600',
                },
                p: {
                  color: 'brand.600',
                },
              }
        }
      >
        <Input type='file' display='none' ref={innerRef} accept={accept} onChange={onHandleFile} />
        <Box
          bg={disabled ? 'gray.500' : 'brand.500'}
          borderRadius='50%'
          width='40px'
          height='40px'
          display='flex'
          justifyContent='center'
          alignItems='center'
        >
          <FeatherIcon name='plus' color='#fff' />
        </Box>
        <Text color={disabled ? 'gray.500' : 'brand.500'}>{label}</Text>
      </Flex>
    </InputGroup>
  );
});
